import React, { useState, useEffect } from 'react';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <a href="#home" className="navbar-logo">MINERVA</a>
        
        <div className="navbar-links">
          <a href="#features" className="navbar-link">Możliwości</a>
          <a href="#architecture" className="navbar-link">Architektura</a>
          <a href="#applications" className="navbar-link">Zastosowania</a>
          <a href="#visualization" className="navbar-link">Wizualizacja</a>
        </div>
        
        <a href="#contact" className="button button-primary navbar-cta">Kontakt</a>
      </div>
    </nav>
  );
};

export default Navbar;